import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSpriteStore } from "@/stores/spriteStore";
import { storeToRefs } from "pinia";
import { useUserInfoStore } from "@/stores/userInfoStore";
import CurrentUserDetailsView from "@/views/app_bar/CurrentUserDetailsView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentUserDetailsPresenter',
  setup(__props) {

const spriteStore = useSpriteStore();
const { currentSprite, isLoading, error } = storeToRefs(spriteStore);
const { getRandomSprite } = spriteStore;

const userInfoStore = useUserInfoStore();
const { loggedIn, displayName, profilePic } = storeToRefs(userInfoStore);
const { setProfilePic, setDisplayName } = userInfoStore;

const saveProfilePic = (newPic: string) => {
  setProfilePic(newPic);
};

const saveDisplayName = (newName: string) => {
  setDisplayName(newName);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CurrentUserDetailsView, {
    "logged-in": _unref(loggedIn),
    name: _unref(displayName),
    "profile-pic": _unref(profilePic),
    "generated-pic": _unref(currentSprite),
    "img-loading": _unref(isLoading),
    "sprite-error": _unref(error),
    onSaveProfilePic: saveProfilePic,
    onSaveDisplayName: saveDisplayName,
    onGenerateNewImage: _unref(getRandomSprite)
  }, null, 8, ["logged-in", "name", "profile-pic", "generated-pic", "img-loading", "sprite-error", "onGenerateNewImage"]))
}
}

})